<script setup>
import { computed } from "vue";
import Notification from "@/utils/plugins/NotificationService";

const props = defineProps({
  modelValue: { type: Boolean, default: false },
  secret: { type: String, default: "" },
  title: { type: String, default: "Aplicación creada con éxito" },
});

const emit = defineEmits(["update:modelValue"]);

const dialogVisible = computed({
  get: () => props.modelValue,
  set: (value) => emit("update:modelValue", value),
});

const copySecret = async () => {
  try {
    await navigator.clipboard.writeText(props.secret);
    Notification.success("Clave secreta copiada al portapapeles.", 3500);
  } catch {
    Notification.error("No se ha podido copiar la clave secreta.", 3500);
  }
};
</script>

<template>
  <el-dialog v-model="dialogVisible" :center="true" width="620px" :show-close="false" :lock-scroll="true"
    class="api-secret-dialog">
    <section v-if="dialogVisible" class="api-secret-dialog__content">
      <button type="button" class="api-secret-dialog__close" aria-label="Cerrar" @click="dialogVisible = false">
        <img src="@/assets/images/aspa_blue_small_entrada.png" alt="" />
      </button>
      <div class="api-secret-dialog__success">
        <el-icon>
          <CircleCheck />
        </el-icon>
      </div>
      <h2>{{ title }}</h2>
      <p class="api-secret-dialog__intro">Copia y guarda esta clave secreta.</p>
      <p class="api-secret-dialog__warning">
        ¡Cópiala ahora: no podrás volver a verla!
      </p>

      <div class="form-item api-secret-dialog__field">
        <label for="api-application-secret">Clave secreta API <span>(Key)</span></label>
        <el-input id="api-application-secret" :model-value="secret" class="w-100" readonly>
          <template #append>
            <el-button aria-label="Copiar clave secreta" @click="copySecret"><el-icon>
                <CopyDocument />
              </el-icon></el-button>
          </template>
        </el-input>
      </div>

      <button type="button" class="btn btn_red api-secret-dialog__confirm" @click="dialogVisible = false">
        HE COPIADO Y GUARDADO LA CLAVE SECRETA
      </button>
    </section>
  </el-dialog>
</template>

<style lang="scss" scoped>
.api-secret-dialog :deep(.el-dialog) {
  border-radius: 20px;
  max-width: calc(100vw - 24px);
}

.api-secret-dialog :deep(.el-dialog__body) {
  padding: 0;
}

.api-secret-dialog__content {
  padding: 18px 34px 28px;
  position: relative;
  text-align: center;
}

.api-secret-dialog__close {
  background: transparent;
  border: 0;
  padding: 0;
  position: absolute;
  right: 16px;
  top: 14px;
}

.api-secret-dialog__close img {
  display: block;
  height: 18px;
  object-fit: contain;
  width: 18px;
}

.api-secret-dialog__success {
  align-items: center;
  background: #e3f8ea;
  border-radius: 50%;
  color: #35bd6f;
  display: inline-flex;
  font-size: 34px;
  height: 58px;
  justify-content: center;
  margin-top: 4px;
  width: 58px;
}

.api-secret-dialog h2 {
  color: #30385d;
  font-size: 1.3rem;
  font-weight: 900;
  margin: 14px 0 5px;
}

.api-secret-dialog__intro {
  color: #7c83a2;
  font-size: 0.9rem;
  margin: 0;
}

.api-secret-dialog__warning {
  color: #f9156f;
  font-size: 0.8rem;
  font-weight: 800;
  margin: 9px 0 16px;
}

.api-secret-dialog__field {
  text-align: left;
}

.api-secret-dialog__field label span {
  color: #7c83a2;
  font-size: 0.85em;
  font-weight: 400;
}

.api-secret-dialog__field :deep(.el-input-group__append) {
  background: #fff;
  border-left: 0;
  box-shadow: none;
  padding: 0 10px;
}

.api-secret-dialog__field :deep(.el-button) {
  color: #474ce6;
  font-size: 18px;
  padding: 0;
}

.api-secret-dialog__confirm {
  color: #fff !important;
  margin-top: 18px;
  min-height: 42px;
  padding-left: 24px;
  padding-right: 24px;
}

@media (max-width: 767px) {
  .api-secret-dialog__content {
    padding: 18px 18px 22px;
  }

  .api-secret-dialog__confirm {
    max-width: 100%;
    width: 100%;
  }
}
</style>
